// class ApiService {
//     constructor() {
//       this.baseUrl = this.getBaseUrl();
//     }
  
//     getBaseUrl() {
//       const FF_ENV = process.env.REACT_APP_FF_ENV || 'azure_dev'; 
//       console.log('FF_ENV', FF_ENV);
//       if (FF_ENV === "dev") {
//         return "http://127.0.0.1:8000";
//       } else if (FF_ENV === "azure_dev") {
//         // return "http://127.0.0.1:8000";
//         return "https://flashfluency-rest-dev-f5e8apg9fkf8fccv.eastus-01.azurewebsites.net";
//       } else if (FF_ENV === "test") {
//         return "https://flashfluency-rest-dev-f5e8apg9fkf8fccv.eastus-01.azurewebsites.net";
//       } else if (FF_ENV === "prod") {
//         return "https://flashfluency-rest-test.azurewebsites.net";
//       } else {
//         throw new Error('Invalid environment configuration');
//       }
//     }
  
//     fetchListeningFlashcardsForUser(userId) {
//       return this.performPost(`${this.baseUrl}/retrieve_listening_flashcards_for_user/`, { user_id: userId });
//     }
  
//     fetchReadingFlashcardsForUser(userId) {
//       return this.performPost(`${this.baseUrl}/retrieve_reading_flashcards_for_user/`, { user_id: userId });
//     }
  
//     postListeningFlashcardResults(data) {
//       return this.performPost(`${this.baseUrl}/post_listening_flashcard_results/`, data);
//     }
  
//     postReadingFlashcardResults(data) {
//       return this.performPost(`${this.baseUrl}/post_reading_flashcard_results/`, data);
//     }

//     postClozeFlashcardResults(data) {
//       return this.performPost(`${this.baseUrl}/post_cloze_results/`, data);
//     }

//     postPronunciationResults(data) {
//       console.log('post res');
//       console.log(data);
//       return this.performPost(`${this.baseUrl}/post_pronunciation_results/`, data);
//     }

//     fetchGrammarLessonsWithProficiency(userId) {
//       return this.performPost(`${this.baseUrl}/get_grammar_lessons_with_proficiency/`, {user_id: userId});
//     }

//     fetchGrammarLessonById(data) {
//       return this.performPost(`${this.baseUrl}/get_grammar_lesson_by_id/`, data);
//     }
    

//     fetchVocabularyLessonsWithProficiency(userId) {
//       return this.performPost(`${this.baseUrl}/get_vocab_lessons_with_proficiency/`, {user_id: userId});
//     }

//     fetchPronunciationRulesWithProficiency(userId) {
//       return this.performPost(`${this.baseUrl}/get_pronunciation_rules_with_user_proficiency/`, {user_id: userId});
//     }

//     fetchVocabLesson(data){
//       return this.performPost(`${this.baseUrl}/get_vocab_lesson/`, data);
//     }
  
//     getAudioSrc(flashcardId, speed) {
//       return `${this.baseUrl}/static/${flashcardId}-${speed}.wav`;
//     }

//     // getSentenceAudio(filename) {
//     //   return this.performPost(`${this.baseUrl}/get_sentence_audio/`, {filename: filename});
//     // }


//     // getSentenceAudio(filename) {
//     //   return this.postForBlob(`${this.baseUrl}/get_sentence_audio/`, { filename })
//     //     .then(blob => URL.createObjectURL(blob));   // 🎧 returns a blob-URL
//     // }

//     getSentenceAudio(flashcardId, speed) {
//       return this.postForBlob(`${this.baseUrl}/get_sentence_audio/`, { 
//         flashcard_id: flashcardId,
//         speed: speed.toString()
//       })
//         .then(blob => URL.createObjectURL(blob));   // 🎧 returns a blob-URL
//     }

//     getSyllableSrcAudio(syllable) {
//       console.log('a: ', syllable)
//       return `${this.baseUrl}/static/syllable_sounds/${syllable}.mp3`;
//     }

//     getVocabWordAudio(word) {
//       // Assumes files are in /static/8k_vocab_11labs/WORD.wav on your backend
//       // Adjust path as needed!
//       return `${this.baseUrl}/static/8k_vocab_11labs/${encodeURIComponent(word)}.wav`;
//     }

//     get_or_create_user_from_google_unique_id(google_unique_id, google_email_address) {
//       return this.performPost(`${this.baseUrl}/get_or_create_user_from_google_unique_id/`, {
//         'google_unique_id':google_unique_id,
//         'google_email_address': google_email_address
//       });
//     }

//     get_user_from_google_unique_id(google_unique_id, google_email_address) {
//       return this.performPost(`${this.baseUrl}/get_user_from_google_unique_id/`, {
//         'google_unique_id':google_unique_id,
//         'google_email_address': google_email_address
//       });
//     }

//     create_user_account(data) {
//       return this.performPost(`${this.baseUrl}/create_user_account/`, data);
//     }

//     postFlashcardDeveloperReview(data) {
//       return this.performPost(`${this.baseUrl}/post_flashcard_dev_review/`, data);
//     }

//     fetchUserStatistics(data){
//       return this.performPost(`${this.baseUrl}/get_user_stats/`, data);
//     }

//     fetchProficiencyPlacementVocabulary(data){
//       return this.performPost(`${this.baseUrl}/get_proficiency_placement_vocabulary/`, data);
//     }

//     getUserProficiencyPlacement(data){
//       return this.performPost(`${this.baseUrl}/get_user_proficiency_placement/`, data);
//     }

//     setUserProficiencyPlacement(data){
//       return this.performPost(`${this.baseUrl}/set_user_proficiency_placement/`, data);
//     }

//     postUserFeedback(data) {
//       return this.performPost(`${this.baseUrl}/save_user_feedback/`, data);
//     }

//     getRandomCloze(data) {
//       return this.performPost(`${this.baseUrl}/get_random_cloze/`, data);
//     }

//     getClozesForUser(data) {
//       return this.performPost(`${this.baseUrl}/get_cloze_flashcards_for_user/`, data);
//     }

//     askFlash(data){
//       return this.performPost(`${this.baseUrl}/ask_flash/`, data);
//     }

//     postAskFlashConversation(data){
//       return this.performPost(`${this.baseUrl}/upsert_ask_flash_conversation/`, data);
//     }

//     testGetRandomFlashcards(data) {
//       return this.performPost(`${this.baseUrl}/test_get_random_flashcards/`,data);
//     }

//     getUserEventValue(data) {
//       return this.performPost(`${this.baseUrl}/get_user_event_value/`,data);
//     }

//     setUserEventValue(data) {
//       return this.performPost(`${this.baseUrl}/set_user_event_value/`,data);
//     }

//     sendBetaSignup(formData) {
//       return this.performPost(`${this.baseUrl}/send_beta_invite/`, formData);
//     }
    
//     getAllVocabTopics(targetLanguage, sourceLanguage) {
//       return this.performPost(`${this.baseUrl}/get_all_vocab_topics/`, {
//         target_language: targetLanguage,
//         source_language: sourceLanguage
//       });
//     }
  
//     createPersonalVocabList(userId, targetLanguage, listName) {
//       return this.performPost(`${this.baseUrl}/create_personal_vocab_list/`, {
//         user_id: userId,
//         target_language: targetLanguage,
//         list_name: listName
//       });
//     }
  
//     updatePersonalVocabList(userId, targetLanguage, listName, listId, vocab) {
//       return this.performPost(`${this.baseUrl}/update_personal_vocab_list/`, {
//         user_id: userId,
//         target_language: targetLanguage,
//         list_name: listName,
//         list_id: listId,
//         vocab: vocab
//       });
//     }
  
//     getAllUserVocabListsForUser(userId, targetLanguage) {
//       return this.performPost(`${this.baseUrl}/get_all_user_vocab_lists_for_user/`, {
//         user_id: userId,
//         target_language: targetLanguage
//       });
//     }
  
//     upsertUserPreferredLearningList(userId, targetLanguage, learningOrder) {
//       console.log('learning order set to api: ', learningOrder)
//       return this.performPost(`${this.baseUrl}/upsert_user_preferred_learning_list/`, {
//         user_id: userId,
//         target_language: targetLanguage,
//         learning_order: learningOrder
//       });
//     }
  
//     getUserPreferredLearningList(userId, targetLanguage) {
//       return this.performPost(`${this.baseUrl}/get_user_preferred_learning_list/`, {
//         user_id: userId,
//         target_language: targetLanguage
//       });
//     }

//     fetchPronunciationFlashcardsForUser(userId, language) {
//       return this.performPost(`${this.baseUrl}/retrieve_pronunciation_flashcards_for_user/`, {
//         user_id: userId,
//         language: language
//       });
//     }

//     postPronunciationAnalysis(data) {
//       // const overrideCloudUrl = "https://flashfluency-rest-dev-f5e8apg9fkf8fccv.eastus-01.azurewebsites.net"
//       // return this.performPost(`${overrideCloudUrl}/analyze_pronunciation/`, data);
//       return this.performPost(`${this.baseUrl}/analyze_pronunciation/`, data);
//     }

//     retrieveReadingFlashcardsForUserForSpecificLesson(data) {
//       return this.performPost(`${this.baseUrl}/retrieve_reading_flashcards_for_user_for_specific_lesson/`, data);
//     }

//     retrieveListeningFlashcardsForUserForSpecificLesson(data) {
//       return this.performPost(`${this.baseUrl}/retrieve_listening_flashcards_for_user_for_specific_lesson/`, data);
//     }

//     retrieveClozeFlashcardsForUserForSpecificLesson(data) {
//       return this.performPost(`${this.baseUrl}/retrieve_cloze_flashcards_for_user_for_specific_lesson/`, data);
//     }

//     retrievePronunciationFlashcardsForUserForSpecificLesson(data) {
//       return this.performPost(`${this.baseUrl}/retrieve_pronunciation_flashcards_for_user_for_specific_lesson/`, data);
//     }


//     // async saveProfessionalSyllableRecording(syllable, audioBlob, language = 'KR') {
//     //   try {
//     //     // Convert blob to base64
//     //     const base64Audio = await this.blobToBase64(audioBlob);
        
//     //     // Determine audio format from blob type
//     //     const audioFormat = this.getAudioFormatFromBlob(audioBlob);
        
//     //     return this.performPost(`${this.baseUrl}/save_professional_syllable_recording/`, {
//     //       syllable: syllable,
//     //       audio_data: base64Audio,
//     //       language: language,
//     //       audio_format: audioFormat
//     //     });
//     //   } catch (error) {
//     //     console.error('Error saving syllable recording:', error);
//     //     throw error;
//     //   }
//     // }
  
//     // async getSyllableRecordingsStatus(language = 'KR') {
//     //   try {
//     //     const response = await fetch(`${this.baseUrl}/get_syllable_recordings_status/?language=${language}`, {
//     //       method: 'GET',
//     //       headers: { 
//     //         'Content-Type': 'application/json',
//     //         // Add your API key header here if needed
//     //       }
//     //     });
  
//     //     if (!response.ok) {
//     //       throw new Error('Network response was not ok');
//     //     }
  
//     //     const jsonResponse = await response.json();
        
//     //     if (jsonResponse && jsonResponse.data) {
//     //       return jsonResponse.data;
//     //     } else {
//     //       throw new Error('Malformed response: no "data" field found');
//     //     }
//     //   } catch (error) {
//     //     console.error('Error fetching syllable status:', error);
//     //     throw error;
//     //   }
//     // }
  
//     // Helper method to convert Blob to base64
//     blobToBase64(blob) {
//       return new Promise((resolve, reject) => {
//         const reader = new FileReader();
//         reader.onloadend = () => {
//           // Remove the data:audio/webm;base64, prefix
//           const base64String = reader.result.split(',')[1];
//           resolve(base64String);
//         };
//         reader.onerror = reject;
//         reader.readAsDataURL(blob);
//       });
//     }

//     getAudioFormatFromBlob(blob) {
//       const mimeType = blob.type;
//       const formatMap = {
//         'audio/webm': 'webm',
//         'audio/wav': 'wav',
//         'audio/mpeg': 'mp3',
//         'audio/mp3': 'mp3',
//         'audio/ogg': 'ogg'
//       };
//       return formatMap[mimeType] || 'webm';
//     }

//     getProfessionallyRecordedSyllableAudio(syllable) {
//       // Assumes files are in /static/8k_vocab_11labs/WORD.wav on your backend
//       // Adjust path as needed!
//       return `${this.baseUrl}/static/professional-syllable-recordings/${syllable}.wav`;
//     }


//     // getProfessionallyRecordedSyllableAudio(data) {
//     //   return this.performPost(`${this.baseUrl}/get_professional_syllable_recording/`, data);
//     // }

//     getUserHangulLessonResults(data) {
//       return this.performPost(`${this.baseUrl}/get_user_hangul_lesson_results/`, data);
//     }
    
//     updateUserHangulLessonResults(data) {
//       return this.performPost(`${this.baseUrl}/update_user_hangul_lesson_results/`, data);
//     }

//     getUserKoreanCurriculumResults(data) {
//       return this.performPost(`${this.baseUrl}/get_user_korean_curriculum_results/`, data);
//     }
    
//     updateUserKoreanCurriculumResults(data) {
//       return this.performPost(`${this.baseUrl}/update_user_korean_curriculum_results/`, data);
//     }

//     getUserSettingsOnLoadin(data) {
//       return this.performPost(`${this.baseUrl}/get_user_settings_on_loadin/`, data);
//     }

//     getKoreanTokensByLesson(data) {
//       return this.performPost(`${this.baseUrl}/get_korean_tokens_by_lesson/`, data);
//     }

//     reportPronunciationError(data) {
//       return this.performPost(`${this.baseUrl}/report_pronunciation_error/`, data);
//     }


//     submitBetaSignup(data) {
//       return this.performPost(`${this.baseUrl}/submit_beta_signup/`, data);
//     }
    
//     getSyllableRecordingsStatus(data) {
//       const { language = 'KR', speaker = 'default' } = data;
//       return this.performGet(`${this.baseUrl}/get_syllable_recordings_status/?language=${language}&speaker=${speaker}`);
//     }
    
//     saveProfessionalSyllableRecording(data) {
//       return this.performPost(`${this.baseUrl}/save_professional_syllable_recording/`, data);
//     }
    
//     getProfessionalSyllableRecording(data) {
//       return this.postForBlob(`${this.baseUrl}/get_professional_syllable_recording/`, data);
//     }

//     // Add these methods to your ApiService class:

//     getSyllableRecordingsStatus(language = 'KR') {
//       return fetch(`${this.baseUrl}/get_syllable_recordings_status/?language=${language}`, {
//         method: 'GET',
//         headers: { 'Content-Type': 'application/json' }
//       })
//       .then(res => res.json())
//       .then(data => data.data);
//     }

//     saveProfessionalSyllableRecording(syllable, audioBase64, language = 'KR', audioFormat = 'webm') {
//       return this.performPost(`${this.baseUrl}/save_professional_syllable_recording/`, {
//         syllable: syllable,
//         audio_data: audioBase64,
//         language: language,
//         audio_format: audioFormat
//       });
//     }

//     async getProfessionalSyllableRecording(syllable, format = 'webm') {
//       const response = await fetch(`${this.baseUrl}/get_professional_syllable_recording/`, {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({ syllable: syllable, format: format })
//       });
      
//       if (!response.ok) {
//         throw new Error('Failed to fetch audio');
//       }
      
//       return response.blob();
//     }


    
//     postForBlob(url, body) {
//       return fetch(url, {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify(body),
//       })
//       .then(res => {
//         if (!res.ok) throw new Error('Network response was not ok');
//         return res.blob();
//       });
//     }

//     performPost(url, data) {
//       return fetch(url, {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify(data)
//       })
//       .then(res => {
//         if (!res.ok) {
//           throw new Error('Network response was not ok');
//         }
//         return res.json();
//       })
//       .then(jsonResponse => {
//         // Check if the response has a 'data' field and return it
//         if (jsonResponse && jsonResponse.data) {
//           return jsonResponse.data;
//         } else {
//           throw new Error('Malformed response: no "data" field found');
//         }
//       })
//       .catch(error => {
//         console.error('Fetching error:', error);
//         throw error;
//       });
//     }

//     performGet(url) {
//       return fetch(url, {
//         method: 'GET',
//         headers: { 'Content-Type': 'application/json' }
//       })
//       .then(res => {
//         if (!res.ok) throw new Error('Network response was not ok');
//         return res.json();
//       })
//       .then(jsonResponse => {
//         if (jsonResponse && jsonResponse.data) {
//           return jsonResponse.data;
//         }
//         throw new Error('Malformed response: no "data" field found');
//       });
//     }

//   }
  
//   export default ApiService;
  







// localStorage slot holding the professional recorder's auth key.
export const RECORDER_KEY_STORAGE = 'syllableRecorderAuthKey';

class ApiService {
  constructor() {
    this.baseUrl = this.getBaseUrl();
  }

  getBaseUrl() {
    const FF_ENV = process.env.REACT_APP_FF_ENV || 'azure_dev'; 
    console.log('FF_ENV', FF_ENV);
    if (FF_ENV === "dev") {
      return "http://127.0.0.1:8000";
    } else if (FF_ENV === "azure_dev") {
      return "https://flashfluency-rest-dev-f5e8apg9fkf8fccv.eastus-01.azurewebsites.net";
    } else if (FF_ENV === "test") {
      return "https://flashfluency-rest-dev-f5e8apg9fkf8fccv.eastus-01.azurewebsites.net";
    } else if (FF_ENV === "prod") {
      return "https://flashfluency-rest-prod.azurewebsites.net";
    } else {
      throw new Error('Invalid environment configuration');
    }
  }

  fetchListeningFlashcardsForUser(userId) {
    return this.performPost(`${this.baseUrl}/retrieve_listening_flashcards_for_user/`, { user_id: userId });
  }

  fetchReadingFlashcardsForUser(userId) {
    return this.performPost(`${this.baseUrl}/retrieve_reading_flashcards_for_user/`, { user_id: userId });
  }

  postListeningFlashcardResults(data) {
    return this.performPost(`${this.baseUrl}/post_listening_flashcard_results/`, data);
  }

  postReadingFlashcardResults(data) {
    return this.performPost(`${this.baseUrl}/post_reading_flashcard_results/`, data);
  }

  postClozeFlashcardResults(data) {
    return this.performPost(`${this.baseUrl}/post_cloze_results/`, data);
  }

  postPronunciationResults(data) {
    console.log('post res');
    console.log(data);
    return this.performPost(`${this.baseUrl}/post_pronunciation_results/`, data);
  }

  fetchGrammarLessonsWithProficiency(userId) {
    return this.performPost(`${this.baseUrl}/get_grammar_lessons_with_proficiency/`, {user_id: userId});
  }

  fetchGrammarLessonById(data) {
    return this.performPost(`${this.baseUrl}/get_grammar_lesson_by_id/`, data);
  }

  fetchVocabularyLessonsWithProficiency(userId) {
    return this.performPost(`${this.baseUrl}/get_vocab_lessons_with_proficiency/`, {user_id: userId});
  }

  fetchPronunciationRulesWithProficiency(userId) {
    return this.performPost(`${this.baseUrl}/get_pronunciation_rules_with_user_proficiency/`, {user_id: userId});
  }

  fetchVocabLesson(data){
    return this.performPost(`${this.baseUrl}/get_vocab_lesson/`, data);
  }

  getAudioSrc(flashcardId, speed) {
    return `${this.baseUrl}/static/${flashcardId}-${speed}.wav`;
  }

  getSentenceAudio(flashcardId, speed) {
    return this.postForBlob(`${this.baseUrl}/get_sentence_audio/`, { 
      flashcard_id: flashcardId,
      speed: speed.toString()
    })
      .then(blob => URL.createObjectURL(blob));
  }

  getSyllableSrcAudio(syllable) {
    console.log('a: ', syllable)
    return `${this.baseUrl}/static/syllable_sounds/${syllable}.mp3`;
  }

  getVocabWordAudio(word) {
    return `${this.baseUrl}/static/8k_vocab_11labs/${encodeURIComponent(word)}.wav`;
  }

  get_or_create_user_from_google_unique_id(google_unique_id, google_email_address) {
    return this.performPost(`${this.baseUrl}/get_or_create_user_from_google_unique_id/`, {
      'google_unique_id':google_unique_id,
      'google_email_address': google_email_address
    });
  }

  get_user_from_google_unique_id(google_unique_id, google_email_address) {
    return this.performPost(`${this.baseUrl}/get_user_from_google_unique_id/`, {
      'google_unique_id':google_unique_id,
      'google_email_address': google_email_address
    });
  }

  create_user_account(data) {
    return this.performPost(`${this.baseUrl}/create_user_account/`, data);
  }

  postFlashcardDeveloperReview(data) {
    return this.performPost(`${this.baseUrl}/post_flashcard_dev_review/`, data);
  }

  fetchUserStatistics(data){
    return this.performPost(`${this.baseUrl}/get_user_stats/`, data);
  }

  fetchProficiencyPlacementVocabulary(data){
    return this.performPost(`${this.baseUrl}/get_proficiency_placement_vocabulary/`, data);
  }

  getUserProficiencyPlacement(data){
    return this.performPost(`${this.baseUrl}/get_user_proficiency_placement/`, data);
  }

  setUserProficiencyPlacement(data){
    return this.performPost(`${this.baseUrl}/set_user_proficiency_placement/`, data);
  }

  postUserFeedback(data) {
    return this.performPost(`${this.baseUrl}/save_user_feedback/`, data);
  }

  getRandomCloze(data) {
    return this.performPost(`${this.baseUrl}/get_random_cloze/`, data);
  }

  getClozesForUser(data) {
    return this.performPost(`${this.baseUrl}/get_cloze_flashcards_for_user/`, data);
  }

  askFlash(data){
    return this.performPost(`${this.baseUrl}/ask_flash/`, data);
  }

  postAskFlashConversation(data){
    return this.performPost(`${this.baseUrl}/upsert_ask_flash_conversation/`, data);
  }

  testGetRandomFlashcards(data) {
    return this.performPost(`${this.baseUrl}/test_get_random_flashcards/`,data);
  }

  getUserEventValue(data) {
    return this.performPost(`${this.baseUrl}/get_user_event_value/`,data);
  }

  setUserEventValue(data) {
    return this.performPost(`${this.baseUrl}/set_user_event_value/`,data);
  }

  sendBetaSignup(formData) {
    return this.performPost(`${this.baseUrl}/send_beta_invite/`, formData);
  }

  getAllVocabTopics(targetLanguage, sourceLanguage) {
    return this.performPost(`${this.baseUrl}/get_all_vocab_topics/`, {
      target_language: targetLanguage,
      source_language: sourceLanguage
    });
  }

  createPersonalVocabList(userId, targetLanguage, listName) {
    return this.performPost(`${this.baseUrl}/create_personal_vocab_list/`, {
      user_id: userId,
      target_language: targetLanguage,
      list_name: listName
    });
  }

  updatePersonalVocabList(userId, targetLanguage, listName, listId, vocab) {
    return this.performPost(`${this.baseUrl}/update_personal_vocab_list/`, {
      user_id: userId,
      target_language: targetLanguage,
      list_name: listName,
      list_id: listId,
      vocab: vocab
    });
  }

  getAllUserVocabListsForUser(userId, targetLanguage) {
    return this.performPost(`${this.baseUrl}/get_all_user_vocab_lists_for_user/`, {
      user_id: userId,
      target_language: targetLanguage
    });
  }

  upsertUserPreferredLearningList(userId, targetLanguage, learningOrder) {
    console.log('learning order set to api: ', learningOrder)
    return this.performPost(`${this.baseUrl}/upsert_user_preferred_learning_list/`, {
      user_id: userId,
      target_language: targetLanguage,
      learning_order: learningOrder
    });
  }

  getUserPreferredLearningList(userId, targetLanguage) {
    return this.performPost(`${this.baseUrl}/get_user_preferred_learning_list/`, {
      user_id: userId,
      target_language: targetLanguage
    });
  }

  fetchPronunciationFlashcardsForUser(userId, language) {
    return this.performPost(`${this.baseUrl}/retrieve_pronunciation_flashcards_for_user/`, {
      user_id: userId,
      language: language
    });
  }

  postPronunciationAnalysis(data) {
    return this.performPost(`${this.baseUrl}/analyze_pronunciation/`, data);
  }

  retrieveReadingFlashcardsForUserForSpecificLesson(data) {
    return this.performPost(`${this.baseUrl}/retrieve_reading_flashcards_for_user_for_specific_lesson/`, data);
  }

  retrieveListeningFlashcardsForUserForSpecificLesson(data) {
    return this.performPost(`${this.baseUrl}/retrieve_listening_flashcards_for_user_for_specific_lesson/`, data);
  }

  retrieveClozeFlashcardsForUserForSpecificLesson(data) {
    return this.performPost(`${this.baseUrl}/retrieve_cloze_flashcards_for_user_for_specific_lesson/`, data);
  }

  retrievePronunciationFlashcardsForUserForSpecificLesson(data) {
    return this.performPost(`${this.baseUrl}/retrieve_pronunciation_flashcards_for_user_for_specific_lesson/`, data);
  }

  getUserHangulLessonResults(data) {
    return this.performPost(`${this.baseUrl}/get_user_hangul_lesson_results/`, data);
  }

  updateUserHangulLessonResults(data) {
    return this.performPost(`${this.baseUrl}/update_user_hangul_lesson_results/`, data);
  }

  getUserKoreanCurriculumResults(data) {
    return this.performPost(`${this.baseUrl}/get_user_korean_curriculum_results/`, data);
  }

  updateUserKoreanCurriculumResults(data) {
    return this.performPost(`${this.baseUrl}/update_user_korean_curriculum_results/`, data);
  }

  getUserSettingsOnLoadin(data) {
    return this.performPost(`${this.baseUrl}/get_user_settings_on_loadin/`, data);
  }

  getKoreanTokensByLesson(data) {
    return this.performPost(`${this.baseUrl}/get_korean_tokens_by_lesson/`, data);
  }

  reportPronunciationError(data) {
    return this.performPost(`${this.baseUrl}/report_pronunciation_error/`, data);
  }

  submitBetaSignup(data) {
    return this.performPost(`${this.baseUrl}/submit_beta_signup/`, data);
  }

  // Professional syllable recording methods
  //
  // These authenticate with a per-recorder key rather than a user token. The
  // key also decides which speaker folder is written, so `speaker` is never
  // sent from here — the server derives it.
  recorderHeaders() {
    const key = localStorage.getItem(RECORDER_KEY_STORAGE);
    return key ? { 'X-Recorder-Key': key } : {};
  }

  verifySyllableRecorderKey() {
    return this.performPost(`${this.baseUrl}/verify_syllable_recorder_key/`, {}, this.recorderHeaders());
  }

  getSyllableRecordingsStatus(data = {}) {
    const { language = 'KR' } = data;
    return this.performGet(
      `${this.baseUrl}/get_syllable_recordings_status/?language=${language}`,
      this.recorderHeaders()
    );
  }

  saveProfessionalSyllableRecording(data) {
    return this.performPost(
      `${this.baseUrl}/save_professional_syllable_recording/`,
      data,
      this.recorderHeaders()
    );
  }

  getProfessionalSyllableRecording(data) {
    return this.postForBlob(
      `${this.baseUrl}/get_professional_syllable_recording/`,
      data,
      this.recorderHeaders()
    );
  }

  // Helper methods

  // Turn a failed response into an error that says what actually went wrong.
  // Without this a 401 and a dead server look identical at the call site.
  async throwForResponse(res) {
    let detail = '';
    try {
      const body = await res.json();
      detail = body?.detail || '';
    } catch (e) {
      // non-JSON error body — fall through to the bare status
    }
    const error = new Error(detail ? `HTTP ${res.status}: ${detail}` : `HTTP ${res.status}`);
    error.status = res.status;
    error.detail = detail;
    throw error;
  }

  postForBlob(url, body, extraHeaders = {}) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...extraHeaders },
      body: JSON.stringify(body),
    })
    .then(res => {
      if (!res.ok) return this.throwForResponse(res);
      return res.blob();
    });
  }

  performPost(url, data, extraHeaders = {}) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...extraHeaders },
      body: JSON.stringify(data)
    })
    .then(res => {
      if (!res.ok) {
        return this.throwForResponse(res);
      }
      return res.json();
    })
    .then(jsonResponse => {
      if (jsonResponse && jsonResponse.data) {
        return jsonResponse.data;
      } else {
        throw new Error('Malformed response: no "data" field found');
      }
    })
    .catch(error => {
      console.error('Fetching error:', error);
      throw error;
    });
  }

  performGet(url, extraHeaders = {}) {
    return fetch(url, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json', ...extraHeaders }
    })
    .then(res => {
      if (!res.ok) return this.throwForResponse(res);
      return res.json();
    })
    .then(jsonResponse => {
      if (jsonResponse && jsonResponse.data) {
        return jsonResponse.data;
      }
      throw new Error('Malformed response: no "data" field found');
    });
  }
}

export default ApiService;